import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CodeHighlight from '../../CodeHighlight';
import changeTargetLinks from '../../../browser/targetLinks';
import styles from './styles.module.styl';

class DownloadInstructions extends Component {
  constructor() {
    super();
    this.downloadInstructionsWrapper = null;
    this.setDownloadInstructionsRef = (elem) => {
      this.downloadInstructionsWrapper = elem;
    };
  }
  componentDidMount() {
    changeTargetLinks(this.downloadInstructionsWrapper, this.props.isFramedMode);
  }
  render() {
    return (
      <CodeHighlight>
        <div
          className={styles.downloadInstructionsWrapper}
          ref={this.setDownloadInstructionsRef}
          dangerouslySetInnerHTML={{ __html: this.props.content }}
        />
      </CodeHighlight>
    );
  }
}

DownloadInstructions.propTypes = {
  content: PropTypes.string.isRequired,
  isFramedMode: PropTypes.bool.isRequired
};

export default DownloadInstructions;
